angular.module('mtic').constant('LOGIN_CONSTANTS', {
  "ACCOUNT_TYPES": {
    "TEACHER": "mtic_teacher",
    "STUDENT": "mtic_student",
    "VRETTA": "mtic_user"
  },
  "GROUP_TYPES": {
    "SCHOOL": "school",
    "CLASS": "mtic_class",
  }
})
